import { H5, P } from "@/components/ui/typography";
import { ContainerPrimary, ContainerSecondary } from "../ui";
import { MISSING_ID_IN_ROUTE, ROLE } from "@/utils/constant";
import { useParams } from "react-router-dom";
import {
  useBulkInsertGPONHPM,
  useIntegrationGPONHPMs,
} from "@/api/generate-hpdb";
import { formatDateTime } from "@/utils/helper/formatDate";
import { SubmitButton } from "@/components/ui/button";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { convertUppercaseLabelToCapitalize } from "../utils/convertUppercaseLabelToCapitalize";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { useEffect } from "react";

interface CreateDataGPONHandlerProps {
  isReadOnly?: boolean;
  onStatusChange: (status: string) => void;
}
export function CreateDataGPONHandler({
  isReadOnly,
  onStatusChange,
}: CreateDataGPONHandlerProps) {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { roles } = useCurrentUser();
  const canAccess =
    roles?.includes(ROLE.ADMINISTRATOR) ||
    roles?.includes(ROLE.VALIDATOR_DOCUMENT_OFFICER);

  const { data: integrationGPONHPMs } = useIntegrationGPONHPMs({ rfsId: id });
  const integrationGPONHPM = integrationGPONHPMs?.[0];

  useEffect(() => {
    if (integrationGPONHPM) {
      onStatusChange(integrationGPONHPM?.status?.toLowerCase());
    }
  }, [integrationGPONHPM, onStatusChange]);

  const { mutate, isPending } = useBulkInsertGPONHPM();

  const handleProcess = () => {
    mutate(
      {
        id: id,
      },
      {
        onSuccess: (result) => {
          const originalData = result.data.original;
          if (originalData.status == "error") {
            swalError.fire({
              text: "Failed upload data GPON to HPM",
            });
          } else {
            swalSuccess.fire({
              text: "Successfully upload data GPON to HPM",
            });
          }
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  };

  return (
    <ContainerPrimary>
      <div className="flex-grow whitespace-nowrap">
        <H5>Create data GPON</H5>
        <P>
          Last Update:{" "}
          {integrationGPONHPM?.updatedDate
            ? formatDateTime(integrationGPONHPM?.updatedDate)
            : "-"}
        </P>
      </div>
      <ContainerSecondary>
        <P className="flex-grow text-axiata-blue dark:text-neutral-300">
          {convertUppercaseLabelToCapitalize(integrationGPONHPM?.status)}
        </P>
        <SubmitButton
          loading={isPending}
          className="ml-auto"
          onClick={handleProcess}
          disabled={isReadOnly || !canAccess || !integrationGPONHPM}
        >
          Process
        </SubmitButton>
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
